var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"my-1"},[_c('vue-signature-pad',{ref:"signaturePad",attrs:{"width":"100%","height":"12.5rem","options":{
                onBegin: _vm.onBegin,
                onEnd: _vm.onEnd,
            }}})],1),_c('div',{staticClass:"d-flex"},[_c('v-messages',{staticClass:"flex-grow-1",attrs:{"role":_vm.hasMessages ? 'alert' : null,"value":_vm.messagesToDisplay,"color":_vm.hasHint ? '' : _vm.validationState}}),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v(" Clear ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }